module.exports = __webpack_public_path__ + "static/media/sfl_3.d4717c2e.jpg";